import { render } from "./appU.vue?vue&type=template&id=b0fe7826"
import script from "./appU.vue?vue&type=script&lang=js"
export * from "./appU.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__